import './Header.css';
import { useState, useEffect, use } from 'react';

const DOG_IMAGES = [
  require("../../media/Textures/Dogs/daisy.png"),
  require("../../media/Textures/Dogs/golden.png"),
  require("../../media/Textures/Dogs/jerry.png"),
  require("../../media/Textures/Dogs/lexi.png"),
  require("../../media/Textures/Dogs/oscar.png"),
  require("../../media/Textures/Dogs/sandy.png"),
  require("../../media/Textures/Dogs/sheapard.png")
];

function getRandomDog(currentDog) {
  const options = DOG_IMAGES.filter(img => img !== currentDog);
  return options[Math.floor(Math.random() * options.length)];
}

function Header({ mode, setMode, currentDog, setCurrentDog }) {

  useEffect(() => {
    setCurrentDog(prev => getRandomDog(prev));
  }, [mode]);

  const handleNavClick = (e) => {
    const mode = e.target.getAttribute("data-mode");
    if (mode) {
      setMode(mode);
    }
  };

  return (
    <header className="Header">
      <div className="title-section">
        <div className="title-subsection">
          <h1>Christina Verton</h1>
          <h3>~ 2D Animator ~</h3>
        </div>
        <img src={currentDog} alt="Current Dog" className="daisy" />
      </div>
      <nav>
        <ul onClick={handleNavClick}>
          <li data-mode="demo">Demo</li>
          <li data-mode="work">Other Work</li>
          <li data-mode="about">About</li>
          <li data-mode="contact">Contact</li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
